module.exports = __webpack_public_path__ + "img/pin-check.3d231aa9.svg";